import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon, Dropdown } from 'semantic-ui-react'
import GlobalContext from '../../../contexts/GlobalContext';
import Auth from '../../../Auth';
import ConfigTheme from '../../../Theme';
import Utility from '../../../Utility';
import './DropdownUser.css';
import {connect} from "react-redux";

/**
 * Component DropdownUser
 * Retourne le select mon compte
 * @param {object} props.history 
 */
const DropdownUser = (props) => {
  const [globalContext] = useContext(GlobalContext);
  //const [isModalRedirect, setIsModalRedirect] = useState(false)
  //const [redirectType, setRedirectType] = useState('')

  /**
   * envent au click deconnecte
   */
  const handleClickDisconnect = () => {
    Auth.logout();
  }

  /**
   * Retourne 
   * @param string code
   * @returns object jsx
   */
  const getItemDropdown = (code) => {
    const data = Utility.getHeaderPage(code, globalContext.translations);
    const siteMap = Utility.getSiteMap(globalContext.translations);
    if (data !== undefined) {
      let { codePage, icon, header } = data;
      return (
        <Dropdown.Item
          as={Link}
          to={Utility.getUrlPage(globalContext, codePage)}
          //onClick={() => props.setActiveItemMenu(siteMap.account.codePage)}
          // onClick={handleUserItemClick}
          onClick={(e) => {
            props.handleRedirectType(() => {
              props.setActiveItemMenu(siteMap.account.codePage)
            }, e)
          }}
          >
          <Icon name={icon} />
          {header}
        </Dropdown.Item>
      )
    }
  }

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <Dropdown
      text={globalContext.translations.myAccount}
      icon="user"
      floating
      id="dropdownUser"
      className={ 'icon ' + (props.className) ? props.className : null}
      style={Object.assign({paddingTop : '25px'}, ConfigTheme.color)}
      item
    >
      <Dropdown.Menu>
        {getItemDropdown('connectionAndSetting')}
        {getItemDropdown('personalInformation')}
        {getItemDropdown('addressCP')}
        {getItemDropdown('additionalInformation')}
        <Dropdown.Divider />

        <Dropdown.Item onClick={handleClickDisconnect}>
          <Icon name="log out" />
          {globalContext.translations.disconnect}
        </Dropdown.Item>

      </Dropdown.Menu>
    </Dropdown>
  )
}

// export default DropdownUser;
const mapDispatch = dispatch => ({
  handleRedirectType: dispatch.authentication.handleRedirectType
})

export default connect(null, mapDispatch)(DropdownUser);